import{ThemeProvider as e}from"@emotion/react";import r from"react";var t=function(t){var o=t.theme,i=void 0===o?{isMobile:!1}:o,m=t.children;return r.createElement(e,{theme:i},m)};export{t as Theme};
//# sourceMappingURL=theme.js.map
